export default {"src":"/_next/static/media/cartReebeloLogo.7445b856.svg","height":13,"width":12};